var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { runtime } from '../../classes/runtime/Runtime';
let TrayBar_ = class TrayBar_ extends React.PureComponent {
    get cycleBar() {
        if (!runtime.availablePackages.Defer)
            return null;
        const { CycleBar } = runtime.availablePackages.Defer.components;
        return React.createElement(CycleBar, { app: this.props.app });
    }
    get backgroundColor() {
        const { app } = this.props;
        if (app.tray.trayBar.isDragHovering)
            return 'yellow';
        if (!app.question)
            return 'rgba(255,255,255,0.5)';
        if (app.question.answeringStepCorrect.showCorrectFeedback_300ms) {
            return 'rgba(127,255,0,0.5)';
        }
        if (app.question.answeringStepMistake.showMistakeFeedback_500ms) {
            return 'rgba(255,0,0,0.5)';
        }
        return 'rgba(255,255,255,0.5)';
    }
    render() {
        const { app } = this.props;
        if (app.appInfo.isMobileAppWebView)
            return null;
        return (React.createElement("div", { style: {
                background: this.backgroundColor,
                display: 'flex',
                height: 45,
                alignItems: 'stretch',
                flexWrap: 'nowrap',
                fontSize: 15,
                zIndex: 1,
            } }, this.cycleBar));
    }
};
TrayBar_ = __decorate([
    observer
], TrayBar_);
export { TrayBar_ };
